export default "__VITE_PUBLIC_ASSET__a2ae49ae__"